import type { Client, RequestContext } from "../client";
import type { ProjectTemplateParameterResource, ProjectTemplateSummary, ProjectTemplateVersionSummary, PropertyValueResource, TemplatedProjectProcessResource } from "../resources";
export class TemplatedProjectRepository {
    protected readonly client: Client;
    protected readonly context: RequestContext;
    constructor(client: Client, requestContext: RequestContext) {
        this.client = client;
        this.context = requestContext;
    }
    getLatestVersionSummary(slug: string) {
        return this.client.get<ProjectTemplateVersionSummary>(this.context, "~/api/spaces/{spaceId}/projecttemplates/{slug}/versionsummary", { slug });
    }
    getProjectTemplateSummary(projectId: string) {
        return this.client.get<ProjectTemplateSummary>(this.context, "~/api/spaces/{spaceId}/projects/{projectId}/template/summary", { projectId });
    }
    getTemplatedProjectDeploymentProcess(projectId: string) {
        return this.client.get<TemplatedProjectProcessResource>(this.context, "~/api/spaces/{spaceId}/projects/{projectId}/template/deploymentprocess", { projectId });
    }
    getTemplatedProjectParameters(projectId: string): Promise<GetTemplatedProjectParametersResponse> {
        return this.client.get<GetTemplatedProjectParametersResponse>(this.context, "~/api/spaces/{spaceId}/projects/{projectId}/template/parameters", {
            projectId,
        });
    }
    getTemplatedProjectParametersInGit(projectId: string, gitRef: string): Promise<GetTemplatedProjectParametersResponse> {
        return this.client.get<GetTemplatedProjectParametersResponse>(this.context, "~/api/spaces/{spaceId}/projects/{projectId}/{gitRef}/template/parameters", {
            projectId,
            gitRef,
        });
    }
    saveTemplateParameterValues(request: SaveTemplateParametersRequest): Promise<void> {
        return this.client.post(this.context, "~/api/spaces/{spaceId}/projects/{projectId}/template/parameters", { parameterValues: request.parameterValues }, {
            spaceId: request.spaceId,
            projectId: request.projectId,
        });
    }
    saveTemplateParameterValuesInGit(request: SaveTemplateParametersInGitRequest): Promise<void> {
        return this.client.post(this.context, "~/api/spaces/{spaceId}/projects/{projectId}/{gitRef}/template/parameters", { parameterValues: request.parameterValues }, {
            spaceId: request.spaceId,
            projectId: request.projectId,
            gitRef: request.gitRef,
        });
    }
}
export interface SaveTemplateParametersRequest {
    spaceId: string;
    projectId: string;
    parameterValues: Record<string, PropertyValueResource>;
}
export interface SaveTemplateParametersInGitRequest {
    spaceId: string;
    projectId: string;
    gitRef: string;
    parameterValues: Record<string, PropertyValueResource>;
}
export interface GetTemplatedProjectParametersResponse {
    Parameters: ProjectTemplateParameterResource[];
    ParameterValues: Record<string, PropertyValueResource>;
}
